import React from 'react';
import PropTypes from 'prop-types';

export const IconFacebook = ({ className }) => (
  <svg className={className} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.184 4.5h-2.368c-1.047 0-2.051.395-2.791 1.098A3.657 3.657 0 0 0 9.868 8.25v2.25H7.5v3h2.368v6h3.158v-6h2.369l.79-3h-3.159V8.25c0-.199.084-.39.232-.53a.811.811 0 0 1 .558-.22h2.368v-3Z" fill="#A3ACB3" />
  </svg>
);

IconFacebook.propTypes = {
  className: PropTypes.string,
};

IconFacebook.defaultProps = {
  className: '',
};
